module.exports = __webpack_public_path__ + "img/7352254.png";